import React from 'react';

// TODO: Replace with final logo
//import {moon} from './logo';
import styles from './SideHeader.module.scss';
import {Link} from 'react-router-dom';

export default function SideHeader() {
  return (
    <div className={styles.SideHeader}>
      <Link to={''} style={{textDecoration: 'none'}}>
        <p className={styles.LogoText}>alto.fm</p>
      </Link>
    </div>
  );
}
